import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './layouts/header'
import Home from './pages/home'
import Pricing from './pages/pricing'
import Sport from './pages/sports'
import How from './pages/how'
import FAQ from './pages/faq';
import Review from './pages/review';
import Footer from './layouts/footer';
import Terms from './pages/legal/Terms';
import Privacy from './pages/legal/Privacy';
import Refund from './pages/legal/Refund';
import Blog from './pages/blog';
import BlogDetail from './components/blogDetail';
import Devices from './pages/devices';
import Wc from './pages/wc/wc';
import OrderSuccess from './pages/orderSuccess';

function LandingPage() {
  return (
    <>
      <main className='bg-gradient-to-br from-black via-gray-900 to-black'>
        <Home />
        <Sport/>
        <Pricing />
        <How/>
        <Review/>
        <Devices/>
        <FAQ/>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/wc" element={<Wc />} />
        <Route path="/pedido-confirmado" element={<OrderSuccess />} />
        <Route path="/pago-exitoso" element={<OrderSuccess />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>
      <Footer/>
    </Router>
  )
}

export default App
